import React, { Component } from 'react';
import Anchor from '../../models/Anchor';
import NavigationService from '../../services/Navigation.service';

type NavigationViewProps = {
    navigationService: NavigationService,
}

type NavigationViewState = {
    anchors: Anchor[],
    activeId: string
}
export default class NavigationView extends Component<NavigationViewProps, NavigationViewState> {

    constructor(props: NavigationViewProps) {
        super(props);

        const anchors: Anchor[] = this.props.navigationService.getNavigation();
        this.state = {
            anchors: anchors,
            activeId: anchors[0].id
        };
        // this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {
        // window.addEventListener('scroll', this.handleScroll);
    };

    componentWillUnmount() {
        // window.removeEventListener('scroll', this.handleScroll);
    };

    // handleScroll(event: Event) {
    //     const offset = window.pageYOffset;

    //     for (const [i, anchor] of this.state.anchors.entries()) {
    //         if ((i === 0 && offset < anchor.position) // Check if scrolled above first item -> mark first item active
    //             || (i + 1 === this.state.anchors.length) // check if last item op loop -> mark last item active
    //             || (anchor.position - 80 <= offset && this.state.anchors[i + 1].position - 50 > offset)// check for the last item with position smaller then offset
    //         ) {
    //             this.setState({ activeId: anchor.id });
    //             break;
    //         }
    //     };
    // };

    public render() {
        return (
            <ul className="list-unstyled pl-2">
                {
                    this.state.anchors.map((anchor: Anchor, index: number) => {
                        return (
                            <li key={index}>
                                <a href={"#" + anchor.id}
                                    className="d-block link-inpage-navigation text-medium"
                                >
                                    {anchor.title}
                                </a>
                                <ul className="list-unstyled pl-4 text-dark font-weight-normal">
                                    {
                                        anchor.children.map((secanchor: Anchor, index: number) => {
                                            return (
                                                <li key={secanchor.id}>
                                                    <a href={"#" + secanchor.id}
                                                        className="d-block link-inpage-navigation text-medium "
                                                    >
                                                        {secanchor.title}
                                                    </a>
                                                    <ul className="list-unstyled pl-4 text-dark font-weight-normal">
                                                        {
                                                            secanchor.children.map((thirdanchor: Anchor, index: number) => {
                                                                return (
                                                                    <a key={thirdanchor.id}
                                                                        href={"#" + thirdanchor.id}
                                                                        className={"link-inpage-navigation text-medium " + (thirdanchor.id === this.state.activeId ? "text-dark-blue font-weight-bold" : "")}
                                                                    >
                                                                        {thirdanchor.title}
                                                                    </a>
                                                                )
                                                            })
                                                        }
                                                    </ul>
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            </li>
                        )
                    })
                }
            </ul>
        );
    }
}